import { createSelector } from 'reselect';
import { LensTypeVariantStepContainer } from '../../../../steps/LensTypeVariantStep/LensTypeVariantStepContainer.js';
import '../../../add-to-cart/selectors.js';
import '../../../bundles/selectors.js';
import '../../../bundles/reducer.js';
import { getSelectedLensType } from '../../selectors.js';
import '../../reducer.js';
import '../../../products/selectors.js';
import '../../../products/reducer.js';

const lensTypeVariantStep = {
    stepStatus: createSelector(getSelectedLensType, (selectedLensType)=>{
        var ref;
        return Number(selectedLensType === null || selectedLensType === void 0 ? void 0 : (ref = selectedLensType.variants) === null || ref === void 0 ? void 0 : ref.length) > 1 ? 'sub-step' : 'hidden';
    }),
    view: LensTypeVariantStepContainer
};

export { lensTypeVariantStep };
//# sourceMappingURL=lens-type-variant.js.map
